/**
 * External dependencies.
 */
import type { GetStaticPaths, GetStaticProps, NextPage } from "next";

/**
 * Internal dependencies.
 */
import { fetchAPI, getLocale, getLocalizationData, getSlug, loadTranslation } from "utils";
import Layout from "layout/layout";
import PageDocIndex from "blocks/page-doc-index/page-doc-index";

const Documentation: NextPage = (props: any) => {
  return (
    <Layout
      title="Documentation"
      desc="Documentation"
      light
      notice
      hreflang={false}
    >
      <PageDocIndex data={props} />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translation = await loadTranslation(
    ctx.locale!,
    process.env.NODE_ENV === "production"
  );
  const locale = getLocale(ctx.locale);

  const { data: globalData } = await fetchAPI("/global", {
    populate: "*",
    locale,
  });
  const { data } = await fetchAPI("/categories", {
    populate: {
      documentations: {
        populate: {
          themes: "*",
          apps: "*"
        }
      },
    },
    sort: "order",
    locale,
  });

  const { data: helpData } = await fetchAPI("/help-centre-landing", {
    populate: "*",
    locale,
  });

  const { data: appData } = await fetchAPI("/apps", {
    populate: "*",
    locale: locale,
  });

  const current = appData.find(({attributes}:any) => attributes.slug_overwrite === ctx?.params?.theme || attributes.slug === ctx?.params?.theme);

  return {
    props: {
      translation,
      categories: data,
      globalData,
      helpData,
      current,
      app: true,
      locale: ctx.locale,
      localizationData: getLocalizationData(current),
    },
    revalidate: 10,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  let paths: any = [];

  const { data } = await fetchAPI("/apps", {
    populate: "*",
  });

  data?.map(({ attributes }: any) => {
    if (attributes.localizations.data) {
      attributes.localizations.data.map((item: any) => {
        paths.push({
          params: { theme: getSlug(item.attributes) },
          locale: item.attributes.locale.toLowerCase(),
        });
      });
    }
    paths.push({
      params: { theme: getSlug(attributes) },
      locale: attributes.locale.toLowerCase(),
    });
  });

  return {
    paths,
    fallback: false,
  };
};

export default Documentation;
